import store from "../store/index";

/**
 * Function to redirect to login page if user isnt authenticated.
 */
export const defaultGuard = (to, from, next) => {
  // if a user is authenticated, redirect to home page.
  if (to.path === "/set-password") {
    next();
  } else {
    if (localStorage.getItem("token")) {
      next({
        path: "/",
      });
    } else {
      next();
    }
  }
};

/**
 * Function to get new token using refresh token.
 */
export const privateGuard = async (to, from, next) => {
  try {
    if (!store.getters["session/loggedIn"]) {
      if (localStorage.getItem("token")) {
        let user = JSON.parse(localStorage.getItem("user"));
        const response = await store.dispatch(
          "session/getNewToken",
          user.userId
        );
        next();
      } else {
        localStorage.clear();
        next({
          path: "/login",
        });
      }
    } else {
      next();
    }
  } catch (e) {
    localStorage.clear();
   
    next({
      path: "/login",
    });
  }
};
